module.exports = __webpack_public_path__ + "static/media/read.55fdf78f.svg";